import { combineReducers } from 'redux';
import { getSuccessActionType } from '../utils';
import { getErrorReducer, getStatusReducer } from './utils/generators';
import { FETCH_CHAPTER } from '../constants/chapter';

function data(state = {}, action) {
  switch (action.type) {
    case getSuccessActionType(FETCH_CHAPTER):
      return action.payload;

    default:
      return state;
  }
}

export default combineReducers({
  status: getStatusReducer([FETCH_CHAPTER]),
  error: getErrorReducer([FETCH_CHAPTER]),
  data
});
